export const LogoEmblem = () => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.2555 27.1111C59.2555 31.0385 56.0071 34.2223 52.0001 34.2223C47.993 34.2223 44.7446 31.0385 44.7446 27.1111C44.7446 23.1838 47.993 20 52.0001 20C56.0071 20 59.2555 23.1838 59.2555 27.1111Z"
        fill="url(#paint0_linear_805_79874)"
      />
      <path
        d="M59.2555 76.8888C59.2555 80.8164 56.0071 84 52.0001 84C47.993 84 44.7446 80.8164 44.7446 76.8888C44.7446 72.9616 47.993 69.7775 52.0001 69.7775C56.0071 69.7775 59.2555 72.9616 59.2555 76.8888Z"
        fill="url(#paint1_linear_805_79874)"
      />
      <path
        d="M30.2335 76.8888C30.2335 80.8164 26.9851 84 22.978 84C18.9709 84 15.7225 80.8164 15.7225 76.8888C15.7225 72.9616 18.9709 69.7775 22.978 69.7775C26.9851 69.7775 30.2335 72.9616 30.2335 76.8888Z"
        fill="url(#paint2_linear_805_79874)"
      />
      <path
        d="M88.2775 76.8888C88.2775 80.8164 85.0291 84 81.0219 84C77.0151 84 73.7667 80.8164 73.7667 76.8888C73.7667 72.9616 77.0151 69.7775 81.0219 69.7775C85.0291 69.7775 88.2775 72.9616 88.2775 76.8888Z"
        fill="url(#paint3_linear_805_79874)"
      />
      <path
        d="M44.7445 51.289C44.7445 55.2164 41.4961 58.4001 37.489 58.4001C33.4819 58.4001 30.2335 55.2164 30.2335 51.289C30.2335 47.3616 33.4819 44.1778 37.489 44.1778C41.4961 44.1778 44.7445 47.3616 44.7445 51.289Z"
        fill="url(#paint4_linear_805_79874)"
      />
      <path
        d="M73.7666 51.289C73.7666 55.2164 70.5182 58.4001 66.511 58.4001C62.5038 58.4001 59.2554 55.2164 59.2554 51.289C59.2554 47.3616 62.5038 44.1778 66.511 44.1778C70.5182 44.1778 73.7666 47.3616 73.7666 51.289Z"
        fill="url(#paint5_linear_805_79874)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_805_79874"
          x1="50.6132"
          y1="47"
          x2="203.053"
          y2="357.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_805_79874"
          x1="50.6132"
          y1="-176.997"
          x2="203.051"
          y2="133.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_805_79874"
          x1="195.723"
          y1="-176.997"
          x2="348.161"
          y2="133.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_805_79874"
          x1="-94.4991"
          y1="-176.997"
          x2="57.9379"
          y2="133.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_805_79874"
          x1="123.168"
          y1="-61.7998"
          x2="275.609"
          y2="248.729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_805_79874"
          x1="51.7225"
          y1="26"
          x2="87.7227"
          y2="92.0003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2024" />
          <stop offset="1" stopColor="#1B2024" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
